import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  endpoint: string = environment.api_url;

  constructor(private http: HttpClient, private messageService: MessageService) { }

  // getEventInvoices(eventShortName: string, filter?: string): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Accept': 'application/json'
  //   });

  //   let params = {};
  //   if (filter) {
  //     params = { 'filter': filter };
  //   }

  //   return this.http.get<Invoice[]>(`${this.endpoint}/events/${eventShortName}/invoices`, { params, headers }).pipe(
  //     catchError(this.handleError<Invoice[]>('getEventInvoices', undefined))
  //   );
  // }

  // getInvoiceDetails(invoiceNumber: string): Observable<{ status: string; message: string }> {
  //   const headers = { 'Accept': 'application/json' };
  //   return this.http.get<{ status: string; message: string }>(
  //     `${this.endpoint}/invoices/details/${invoiceNumber}`,
  //     { headers, responseType: 'json' }
  //   ).pipe(
  //     catchError(this.handleError<{ status: string; message: string }>('getInvoiceDetails'))
  //   );
  // }

  getPDFInvoice(invoiceNumber: String): Observable<ArrayBuffer> {
    return this.http.get<ArrayBuffer>(`${this.endpoint}/invoices/${invoiceNumber}`,
      {
        headers: { 'Accept': 'application/pdf' },
        responseType: 'arraybuffer' as 'json'
      }).pipe(
        catchError(this.handleError<ArrayBuffer>('getInvoice', undefined))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.log('handleError');
      const statusCode = error?.status || 'Unknown status';
      let errorMessage = 'An unexpected error occurred';

      if (error?.error instanceof ArrayBuffer) {
        try {
          // Decode the ArrayBuffer and parse it as JSON
          const decodedText = new TextDecoder().decode(error.error);
          const errorJson = JSON.parse(decodedText);
          errorMessage = errorJson?.message || 'An unexpected error occurred';
        } catch (e) {
          console.error('Failed to parse error body as JSON:', e);
        }
      } else if (error?.error?.message) {
        // If error.error is already JSON, extract the message
        errorMessage = error.error.message;
      } else if (error.message) {
        // Handle fallback cases
        errorMessage = error.message;
      }

      console.error(`${operation} failed: [${statusCode}] ${errorMessage}`);
      this.messageService.showMessage(`Error: ${errorMessage}`, true);

      return throwError(() => error);

     // return of(result as T);
    };
  }
}

